import { z } from "zod";

import { executionSourceSchema } from "../import";

import { auditEventTypeSchema } from "./audit-event-type";
import { auditEventBaseSchema } from "./audit-event-base";

const auditEventImportingFailedDataSchema = z.object({
	failureReason: z.string(),
	executionSource: executionSourceSchema,
});

export const auditEventImportingFailedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.ImportingFailed),
	data: auditEventImportingFailedDataSchema,
});

export type AuditEventImportingFailed = z.infer<typeof auditEventImportingFailedSchema>;
